import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Divider, makeStyles } from '@material-ui/core';
import merge from 'lodash/merge';
import { useDrawerContext } from '../../../context/DrawerContext';
const useStyles = makeStyles((theme) => ({
    contentWrapper: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
    },
    subHeader: {
        padding: theme.spacing(0.4, 3, 0),
    },
}));
export const DrawerHeader = (props) => {
    const classes = useStyles();
    const { headerProps: contextProps } = useDrawerContext();
    // Merge headerProps(contextProps) with props, giving precedence to props
    const mergedProps = merge({}, contextProps, props);
    const { subHeader, className, content, divider, contentRight } = mergedProps;
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: className, children: [_jsxs("div", { className: classes.contentWrapper, children: [content && content, contentRight && contentRight] }), _jsx(Divider, {}), subHeader && _jsx("div", { className: classes.subHeader, children: subHeader })] }), divider && _jsx(Divider, {})] }));
};
